// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ArrowDown from "@insite/mobius/Icons/ArrowDown";
import { welcomeAccountStyles } from "@rpsc/App/Widgets/WelcomeAccount/WelcomeAccount";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, linkArrowStyle, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

welcomeAccountStyles.wrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 24px;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
        }

        ${xScreen("lte", "sm")} {
            gap: 16px;
        }
    `,
};

welcomeAccountStyles.customerWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        column-gap: 24px;
        row-gap: 8px;

        ${xScreen("lte", "sm")} {
            align-items: flex-start;
            flex-direction: column;
        }
    `,
};

welcomeAccountStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: baseline;
        justify-content: space-between;
        gap: 24px;

        ${xScreen("lte", "md")} {
            width: 100%;
        }

        ${xScreen("lte", "sm")} {
            align-items: flex-start;
            flex-direction: column;
            gap: 16px;
        }
    `,
};

welcomeAccountStyles.customerName = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

welcomeAccountStyles.customerNumber = {
    color: "common.black",
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 0;
    `,
};

welcomeAccountStyles.link = {
    ...mergeWithCss(linkArrowStyle, {
        typographyProps: {
            size: 12,
            lineHeight: "14px",
        },
        css: css`
            ${IconWrapper}, svg {
                width: 11px;
                height: 13px;
            }
            ${xScreen("lte", "md")} {
                align-self: center;
            }
            ${xScreen("lt", "sm")} {
                align-self: flex-start;
            }
        `,
    }),
};

welcomeAccountStyles.ctaButton = {
    mergeCss: true,
    variant: "primary",
    icon: {
        src: ArrowDown,
        position: "right",
    },
    css: css`
        ${IconWrapper}, svg {
            width: 16px;
            height: 16px;
            top: 0;
        }
    `,
};
